import { useWatch } from "react-hook-form";
import AssignmentTypeComp from "../AssignmentTypeComp";
import IterationTypeComp from "../ItearationTypeComp";
import RestTypeComp from "../RestTypeComp";
import RuleTypeComp from "../RuleTypeComp";

const RuleTypeSwitch = ({ control, register, path, rule, schema, depth }) => {
  const type = useWatch({
    control,
    name: `${path}.TYPE`,
    defaultValue: rule?.TYPE ?? "RULE",
  });

  switch (type) {
    case "ITERATION":
      return (
        <IterationTypeComp
          control={control}
          register={register}
          schema={schema}
          rule={rule}
          path={path}
          depth={depth}
        />
      );

    case "ASSIGNMENT":
      return <AssignmentTypeComp control={control} path={path} />;

    case "REST":
      return <RestTypeComp control={control} path={path} rule={rule} />;

    default:
      return (
        <RuleTypeComp
          control={control}
          register={register}
          path={path}
          rule={rule}
          schema={schema}
          depth={depth}
        />
      );
  }
};

export default RuleTypeSwitch;
